<script lang="ts" setup>
    import { computed, onMounted, ref, watch } from 'vue'
    import { useAwsStore } from '~~/stores/aws'
    import type { PickerContext } from '../../composables/usePickerRegistry'

    const props = defineProps<{
        modelValue: string | null
        context?: PickerContext
        readonly?: boolean
        dense?: boolean
        outlined?: boolean
        borderless?: boolean
        label?: string
    }>()

    const emit = defineEmits<{
        (e: 'update:modelValue', value: string): void
    }>()

    const awsStore = useAwsStore()
    const submitted = ref<string[]>([])

    const suggestions = computed(() => {
        const q = (props.modelValue ?? '').toLowerCase()
        return q
            ? submitted.value.filter((r) => r.toLowerCase().includes(q))
            : submitted.value
    })

    async function fetchSubmitted() {
        if (!props.context?.providerOptionId) return
        submitted.value = await awsStore.fetchSubmittedRegions(props.context.providerOptionId)
    }

    onMounted(fetchSubmitted)
    watch(() => props.context?.providerOptionId, fetchSubmitted)
</script>

<template>
    <q-input
        :model-value="modelValue ?? ''"
        :label="label ?? 'AWS Region'"
        :readonly="readonly"
        :dense="dense"
        :outlined="outlined"
        :borderless="borderless"
        autocomplete="off"
        @update:model-value="(v) => emit('update:modelValue', String(v))"
    >
        <q-menu
            v-if="suggestions.length"
            no-focus
            no-refocus
            fit
            anchor="bottom left"
            self="top left"
        >
            <q-list dense>
                <q-item
                    v-for="s in suggestions"
                    :key="s"
                    clickable
                    @click="emit('update:modelValue', s)"
                >
                    <q-item-section>{{ s }}</q-item-section>
                </q-item>
            </q-list>
        </q-menu>
    </q-input>
</template>
